import { PlusIcon } from '@airship-platform/jam-web/icons';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router';
import { useAppointmentProposalOptions } from '../../../data-access/appointmentProposalOptions';

interface AddSowButtonProps {
  variant?: 'button' | 'iconButton';
}

const AddSowButton: React.FC<AddSowButtonProps> = ({ variant = 'button' }) => {
  const { currentOption } = useAppointmentProposalOptions();

  const isReadOnly = currentOption?.isReadOnly || false;

  if (variant === 'iconButton') {
    return (
      <IconButton
        component={Link}
        to="query-sow"
        color="gold"
        size="small"
        disabled={isReadOnly}
      >
        <PlusIcon />
      </IconButton>
    );
  }

  return (
    <Button
      component={Link}
      to="query-sow"
      color="softGold"
      endIcon={<PlusIcon />}
      disabled={isReadOnly}
    >
      Add
    </Button>
  );
};

export default AddSowButton;
